const seafoodData = {
  hero_section: {
    title: "Fresh Seafood Collection",
    description: "100% Natural • Premium Quality • Ocean Fresh",
    src: "videos/seafood.webm",
  },
  description: {
    title: "Premium Seafood Collection",
    main_description:
      "Discover our range of fresh and premium seafood, carefully sourced and prepared to deliver the authentic taste of the ocean.",
    segment_description:
      "Effortless seafood preparation with our ready-to-cook fish and prawns.",
    variety_description:
      "Available in a variety of cuts and sizes to suit every culinary need.",
  },
  "products": [
    {
      "id": "1",
      "name": "Fresh Pangassius Fillets",
      "image": "fs_indian_basa.webp",
      "type": "fish",
      "features": [
        "Fresh from the ocean",
        "Ready to cook",
        "Perfect for grilling",
        "High in protein",
        "Low in fat",
        "High in omega-3"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    {
      "id": "2",
      "name": "Fresh Seer Fish Steaks",
      "image": "fs_seer_fish.webp",
      "type": "fish",
      "features": [
        "Fresh seer fish",
        "Perfect for steaming",
        "Rich in omega-3",
        "Ideal for traditional recipes"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    {
      "id": "3",
      "name": "Fresh Anchovies Nethili",
      "image": "fs_anchovies_nethili.webp",
      "type": "fish",
      "features": [
        "Fresh anchovies",
        "Perfect for grilling",
        "High in protein",
        "Low in fat",
        "High in omega-3"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    {
      "id": "4",
      "name": "Fresh Fish Fingers",
      "image": "fs_fish_fingers.webp",
      "type": "fish",
      "features": [
        "Fresh fish fingers",
        "Perfect for grilling",
        "High in protein",
        "Low in fat",
        "High in omega-3"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    {
      "id": "5",
      "name": "Fresh Fish Cutlets",
      "image": "fs_fish_cutlet.webp",
      "type": "fish",
      "features": [
        "Fresh fish cutlets",
        "Perfect for gravies",
        "Rich in flavor",
        "Easy to cook"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    {
      "id": "6",
      "name": "Fish Steaks",
      "image": "fish_steaks.webp",
      "type": "fish",
      "features": [
        "Thick fish steaks",
        "Perfect for grilling",
        "High protein content",
        "Ideal for BBQ"
      ],
      "meta": {
        "weight": "1kg Pack"
      }
    },
    // Shrimp products
    {
      "id": "7",
      "name": "Prawn Crumble Balls",
      "image": "fs_prawn_crumble_ball.webp",
      "type": "shrimp",
      "features": ["Crispy prawn balls", "Perfect for appetizers", "Juicy and tender"],
      "meta": {"weight": "1kg Pack"}
    },
    {
      "id": "8",
      "name": "Shrimp Samosa",
      "image": "fs_shrimp_samosa.webp",
      "type": "shrimp",
      "features": ["Stuffed with shrimp", "Crispy pastry", "Great for snacks"],
      "meta": {"weight": "1kg Pack"}
    },
    {
      "id": "9",
      "name": "Shrimp Spring Rolls",
      "image": "fs_shrimp_spring_rolls.webp",
      "type": "shrimp",
      "features": ["Filled with shrimp", "Crispy rolls", "Easy to cook"],
      "meta": {"weight": "1kg Pack"}
    },
    {
      "id": "10",
      "name": "Breaded Butterfly Shrimp",
      "image": "fs_breaded_butterfly_shrimp.webp",
      "type": "shrimp",
      "features": ["Butterflied shrimp", "Crispy breaded coating", "Quick snack or meal"],
      "meta": {"weight": "1kg Pack"}
    },
    {
      "id": "11",
      "name": "Breaded Popcorn Shrimp",
      "image": "fs_breaded_popcorn_shrimp.webp",
      "type": "shrimp",
      "features": ["Bite-sized shrimp", "Crispy breaded coating", "Perfect for parties"],
      "meta": {"weight": "1kg Pack"}
    },
    {
      "id": "12",
      "name": "Raw Frozen Shrimp PD",
      "image": "fs_raw_frozen_shrimp_pd.webp",
      "type": "shrimp",
      "features": ["Peeled and deveined", "Frozen for freshness", "Ready to cook"],
      "meta": {"weight": "1kg Pack"}
    },
    // Squid product
    {
      "id": "13",
      "name": "Breaded Squid Rings",
      "image": "fs_breaded_squid_rings.webp",
      "type": "squid",
      "features": ["Tender squid rings", "Crispy breaded coating", "Perfect for frying"],
      "meta": {"weight": "1kg Pack"}
    }
  ],

  features: [
    {
      id: 1,
      title: "Fresh from the Ocean",
      description: "Sourced directly from trusted fishermen and sustainable fisheries.",
    },
    {
      id: 2,
      title: "Ready to Cook",
      description: "Pre-cleaned and portioned for immediate use in your kitchen.",
    },
    {
      id: 3,
      title: "Rich in Nutrients",
      description: "High in protein, omega-3 fatty acids, and essential minerals.",
    },
    {
      id: 4,
      title: "Versatile Cooking",
      description: "Perfect for grilling, frying, steaming, curries, and more.",
    },
  ],
  text_section: {
    title: "Fresh Seafood",
    description: "Our seafood collection brings the authentic taste of the ocean to your table. Carefully sourced from sustainable fisheries and prepared with traditional methods, each piece delivers the pure, fresh flavor that seafood lovers crave.",
  },
  feature_text_section: {
    title: "Chef's Choice Seafood",
    subline: "From ocean to plate – fresh, flavorful, and ready to impress!",
    description:
      "Perfect for restaurants, hotels, and home kitchens—our seafood saves prep time and ensures consistent quality and taste.",
  },
  feature_cards_info_card: [
    {
      id: 1,
      image: "fs_horeca_1.webp",
      title: "Quick Preparation",
      description:
        "Pre-cleaned and portioned seafood eliminates time-consuming prep, allowing your kitchen to serve fresh dishes faster.",
    },
    {
      id: 2,
      image: "fs_horeca_2.webp",
      title: "Consistent Quality",
      description:
        "Every batch meets our strict quality standards, ensuring uniform taste and texture in every dish.",
    },
    {
      id: 3,
      image: "fs_horeca_3.webp",
      title: "Versatile Applications",
      description:
        "Perfect for various cuisines: from traditional curries to modern fusion dishes and international recipes.",
    },
  ],
  overlay_card: [
    {
      id: 1,
      key: "Fresh from Ocean",
      image: "ocean_fresh.webp",
      title: "Fresh from Ocean",
      description:
        "Sourced directly from sustainable fisheries for the freshest taste and highest quality",
    },
    {
      id: 2,
      key: "Chef-ready Convenience",
      image: "Chef-ready_Convenience.webp",
      title: "Chef-ready Convenience",
      description:
        "Pre-cleaned and portioned for immediate use, saving valuable prep time in any kitchen",
    },
    {
      id: 3,
      key: "Premium Quality",
      image: "Consistent_Quality.webp",
      title: "Premium Quality",
      description:
        "Rigorous quality control ensures every piece meets our high standards for taste and freshness",
    },
    {
      id: 4,
      key: "Versatile Cooking",
      image: "Versatile_Cooking_Options.webp",
      title: "Versatile Cooking",
      description:
        "Perfect for grilling, frying, steaming, curries, and international cuisines",
    },
  ],
  why_choose_section: {
    title: "Why Choose Our Seafood",
    description: "Discover the perfect blend of freshness, quality, and convenience that makes our seafood stand out from the rest.",
  },
};

export default seafoodData; 